import React from 'react';
import PropTypes from 'prop-types';
import FullScreenDialog, {
  FullScreenDialogContent
} from '../../UI/FullScreenDialog';
import Paper from '@material-ui/core/Paper';
import CircularProgress from '@material-ui/core/CircularProgress';
import { intlShape, FormattedMessage } from 'react-intl';

import CommunicatorDialogBoardItem from './CommunicatorDialogBoardItem.component';
import messages from './CommunicatorDialog.messages';

import './CommunicatorDialog.css';

const CommunicatorDialog = ({
  open,
  intl,
  loading,
  boards,
  total,
  onClose,
  deleteBoard,
  dark
}) => (
  <FullScreenDialog
    disableSubmit={true}
    open={open}
    title={intl.formatMessage(messages.title)}
    onClose={onClose}
  >
    <Paper className={dark ? 'is-dark' : ''}>
      <FullScreenDialogContent className="CommunicatorDialog__container">
        <div className="CommunicatorDialog__communicatorData">
          <div className="CommunicatorDialog__communicatorData__title">
            {intl.formatMessage(messages.title)}
          </div>
          <div className="CommunicatorDialog__communicatorData__boardsQty">
            {intl.formatMessage(messages.boardsQty, { qty: total })}
          </div>
        </div>

        <div className="CommunicatorDialog__content">
          {!loading && (
            <div className="CommunicatorDialog__boards">
              {!boards.length && (
                <div className="CommunicatorDialog__boards__emptyMessage">
                  <FormattedMessage {...messages.emptyBoardsList} />
                </div>
              )}

              {boards.map((board, i) => (
                <CommunicatorDialogBoardItem
                  key={board._id || board.id || i}
                  board={board}
                  intl={intl}
                  deleteBoard={deleteBoard}
                  dark={dark}
                />
              ))}
            </div>
          )}

          {loading && (
            <CircularProgress
              size={35}
              className="CommunicatorDialog__spinner"
              thickness={7}
            />
          )}
        </div>
      </FullScreenDialogContent>
    </Paper>
  </FullScreenDialog>
);

CommunicatorDialog.defaultProps = {
  open: false,
  loading: false,
  boards: [],
  total: 0,
  onClose: () => {}
};

CommunicatorDialog.propTypes = {
  boards: PropTypes.array,
  total: PropTypes.number,
  open: PropTypes.bool,
  loading: PropTypes.bool,
  intl: intlShape,
  onClose: PropTypes.func,
  deleteBoard: PropTypes.func.isRequired,
  dark: PropTypes.bool
};

export default CommunicatorDialog;
